import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";
import type { EditorValue } from "../../../services/api/instances/editorApi/types";
import {
  getEditorMessagesReducerBuilder,
  postMessageWithResponsesReducerBuilder,
  uploadFileToEditorDialogReducerBuilder,
} from "./reducers";
import type { EditorState } from "./types";
import { ChatCompletionsMessageObject } from "../../../services/api/instances/completionsApi/types";

const initialState: EditorState = {
  spaValue: null,
  messages: [],
  isMessageLoading: false,
  isFileLoading: false,
};

const editorSlice = createSlice({
  name: "editor",
  initialState,
  reducers: {
    setSpaValue: (state, action: PayloadAction<EditorValue>) => {
      state.spaValue = action.payload;
    },
    addUserMessage: {
      reducer(
        state: EditorState,
        action: PayloadAction<ChatCompletionsMessageObject>,
      ) {
        state.messages.push(action.payload);
      },
      prepare(content: string) {
        return {
          payload: {
            role: "user",
            content,
          },
        };
      },
    },
    clearMessagesAction: (state) => {
      state.messages = [];
    },
    clearEditorState: () => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    postMessageWithResponsesReducerBuilder(builder);
    getEditorMessagesReducerBuilder(builder);
    uploadFileToEditorDialogReducerBuilder(builder);
  },
});

export const editorReducers = editorSlice.reducer;

export const {
  addUserMessage,
  setSpaValue,
  clearMessagesAction,
  clearEditorState,
} = editorSlice.actions;
